(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var ForwardForm = require("./forwardform");

function account_runtime(ev) {
  var delete_forms = document.querySelectorAll(".address-delete-form");
  delete_forms.forEach(function (delete_form) {
    delete_form.addEventListener("submit", function (ev) {
      ev.preventDefault();
      var confirmed = confirm("Are you sure you want to delete this address?");

      if (confirmed) {
        var forward = new ForwardForm(delete_form);
        var submit_button = delete_form.querySelector("[type='submit']");
        submit_button.innerText = "Deleting...";
        forward.send(delete_form.getAttribute("action"), delete_form.getAttribute("method")).then(function (event) {
          delete_form.closest(".address").remove();
          var wrapper = document.querySelector(".addresses-wrapper ");

          if (wrapper.querySelectorAll(".address").length === 0) {
            wrapper.classList.add("empty");
          } else {
            wrapper.classList.remove("empty");
          }
        })["catch"](function (err) {
          console.log(err);
        });
      }
    });
  });
  var cancel_buttons = document.querySelectorAll(".cancel-form");
  cancel_buttons.forEach(function (button) {
    button.addEventListener("click", function (ev) {
      ev.preventDefault();
      button.closest(".hidden-address-form").classList.remove("active");
    });
  });
  var add_new_button = document.querySelector(".add-new-btn");

  if (add_new_button) {
    add_new_button.addEventListener("click", function (ev) {
      ev.preventDefault();
      var form = add_new_button.parentElement.nextElementSibling;

      if (form.classList.contains("active")) {
        add_new_button.innerText = "Add New";
        form.classList.remove("active");
      } else {
        add_new_button.innerText = "Cancel";
        form.classList.add("active");
      }
    });
  }

  var new_address_form = document.querySelector(".new-address-form form");

  if (new_address_form) {
    new_address_form.addEventListener("submit", function (ev) {
      ev.preventDefault();
      new_address_form.querySelector("[type='submit']").value = "Loading...";
      var fform_new = new ForwardForm(new_address_form);
      fform_new.send(new_address_form.getAttribute("action"), new_address_form.getAttribute("method")).then(function (data) {
        location.reload();
      })["catch"](function (err) {
        console.log(err);
      });
    });
  }

  var view_details_buttons = document.querySelectorAll(".view-details");

  if (view_details_buttons) {
    view_details_buttons.forEach(function (button) {
      button.addEventListener("click", function (ev) {
        ev.preventDefault();
        var hidden_wrapper = button.closest(".order").querySelector(".hidden-wrapper");

        if (hidden_wrapper.classList.contains("hide")) {
          hidden_wrapper.classList.remove("hide");
          button.innerText = "Hide Details";
        } else {
          hidden_wrapper.classList.add("hide");
          button.innerText = "View Details";
        }
      });
    });
  }

  function get_provinces(option, selector) {
    var provinces = JSON.parse(option.getAttribute("data-provinces"));
    var province_selector = selector.closest('form').querySelector("[name='address[province]']");

    if (provinces.length === 0) {
      province_selector.parentElement.classList.add("empty");
    } else {
      province_selector.parentElement.classList.remove("empty");
    }

    var def = province_selector.getAttribute("value");
    province_selector.innerHTML = "";
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = provinces[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var province = _step.value;
        var new_option = document.createElement("option");

        if (def == province[1]) {
          new_option.selected = true;
        }

        new_option.text = province[0];
        new_option.value = province[1];
        province_selector.add(new_option);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  var country_selectors = document.querySelectorAll("[name='address[country]']");

  if (country_selectors) {
    country_selectors.forEach(function (selector) {
      get_provinces(selector.options[selector.selectedIndex], selector);
      selector.addEventListener("change", function (ev) {
        get_provinces(selector.options[selector.selectedIndex], selector);
      });
    });
  }

  var country_options = document.querySelectorAll("[name='address[country]'] option");
  var edit_address_forms = document.querySelectorAll(".address-edit-form");

  if (edit_address_forms) {
    edit_address_forms.forEach(function (form) {
      form.addEventListener("submit", function (ev) {
        ev.preventDefault();
        var hidden_address_forms = form.closest(".address").querySelector(".hidden-address-form");

        if (hidden_address_forms.classList.contains("active")) {
          hidden_address_forms.classList.remove("active");
        } else {
          hidden_address_forms.classList.add("active");
        }
      });
    });
  }
}

module.exports = account_runtime;

},{"./forwardform":4}],2:[function(require,module,exports){
"use strict";

var _require = require("./helpers"),
    all_ev = _require.all_ev,
    get = _require.get;

var Message = require("./message");

function cart_runtime(ev) {
  function update_cart(item) {
    cart_runtime.last_changed = item;
    var line_number = item.getAttribute("data-line-number");
    var quantity = item.value;

    if (quantity == 0) {// item.closest(".cart-item").remove();
    } else {
      CartJS.updateItemById(line_number, quantity);
    }
  }

  all_ev("[name='updates[]']", "change", function (item, ev) {
    cart_runtime.last_changed = item;
    var line_number = item.getAttribute("data-line-number");
    var quantity = item.value;

    if (quantity == 0) {// item.closest(".cart-item").remove();
    } else {
      CartJS.updateItemById(line_number, quantity);
    }
  });
  var update_button = document.querySelector(".update-cart-btn");

  if (update_button) {
    update_button.addEventListener("click", function (ev) {
      cart_runtime.update(CartJS.cart);
      var items = document.querySelectorAll('.cart-item .total-price');

      var _loop = function _loop(i) {
        var quantity = items[i].parentElement.querySelector(".quantity");

        if (quantity.value == 0) {
          var line_number = quantity.getAttribute("data-line-number");
          CartJS.updateItemById(line_number, quantity.value);
          quantity.parentElement.remove();
        }

        items[i].classList.add('change');
        setTimeout(function () {
          items[i].classList.remove('change');
        }, 400);
      };

      for (var i = 0; i < items.length; i++) {
        _loop(i);
      }
    });
  }

  var quantity_buttons = document.querySelectorAll(".quantity .before, .quantity .after");
  quantity_buttons.forEach(function (btn) {
    btn.addEventListener("click", function (ev) {
      var input = btn.closest(".quantity").querySelector("input");
      var add = 1;
      if (btn.classList.contains("after")) add = -1;
      input.value = parseInt(input.value) + add;
      update_cart(input);
    });
  });

  if (document.querySelector(".cart-wrapper.empty")) {
    new Message("Your cart is empty", "error");
  }
} // This is the function for the animation
// Just needs triggered 200ms before the new total is rendered on the screen, but after it has been calculated


function cart_update_animation(totalElement) {
  totalElement.classList.add('change');
  setTimeout(function () {
    totalElement.classList.remove('change');
  }, 400);
}

cart_runtime.money = function (figure) {
  return "$" + (figure / 100).toFixed(2);
};

cart_runtime.update = function (cart) {
  cart.items.forEach(function (cart_item) {
    var query_text = "[data-item-key='".concat(cart_item.key, "']");
    var cart_item_dom = get(query_text, document);
    setTimeout(function () {
      cart_item_dom.querySelector(".total-price").innerText = "$" + (cart_item.line_price / 100).toFixed(2);
    }, 200);
  });
  get(".total .value").innerText = cart_runtime.money(cart.total_price);
  get(".subtotal .value").innerText = cart_runtime.money(cart.original_total_price);
};

module.exports = cart_runtime;

},{"./helpers":6,"./message":9}],3:[function(require,module,exports){
"use strict";

function faq_runtime() {
  var faq_input = document.querySelector(".search input");
  var questions_and_answers = Array.from(document.querySelectorAll(".question-answer"));
  var heading = document.querySelector(".heading");
  heading.style.maxHeight = heading.offsetHeight + "px";
  window.addEventListener("resize", function (e) {
    return heading.style.maxHeight = heading.offsetHeight + "px";
  });
  var old_height = 0;
  faq_input.addEventListener("input", function (ev) {
    var search_term = ev.target.value;

    if (ev.target.value.length > 0) {
      if (old_height === 0) {
        old_height = heading.offsetHeight;
      }

      heading.style.maxHeight = "0px";
    } else {
      heading.style.maxHeight = old_height + "px";
    }

    questions_and_answers.forEach(function (q_a) {
if (q_a && q_a.innerText && q_a.innerText.toLowerCase().includes(search_term.toLowerCase())) {
    q_a.classList.add("active");
}
console.log("good")
        if (q_a.classList.contains('grey')) {
          q_a.querySelector('animate#forward').beginElement();
          q_a.classList.remove("grey");
        }
       else {
        q_a.classList.remove("active");

        if (!q_a.classList.contains('grey')) {
          q_a.classList.add("grey");
      q_a.querySelector('animate#backward').beginElement();
        }
      }
    });
  });
}
module.exports = faq_runtime;
 },{}],4:[function(require,module,exports){
"use strict";

function ForwardForm(form) {
  if (typeof form === "undefined") throw "Must provide a form";
  var fform = Object.create(ForwardForm.prototype);
  fform.form = form;
  fform.collect();
  return fform;
}

ForwardForm.prototype = {
  collect: function collect() {
    this.form_data = new FormData(this.form);
  },
  send: function send(url, method) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (typeof method === "undefined") method = "POST";
      if (typeof url === "undefined") throw "URL must be set to continue";
      var request;
      _this.request = request = new XMLHttpRequest();
      request.addEventListener("load", function (data) {
        resolve(data);
      });
      request.addEventListener("error", function (err) {
        return reject(err);
      });
      request.open(method, url);
      request.send(_this.form_data);
    });
  },
  done: function done(data) {}
};
module.exports = ForwardForm;

},{}],5:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Hamburger =
/*#__PURE__*/
function () {
  function Hamburger(mobile_menu, hamburger_menu, mobile_menu_open_class) {
    _classCallCheck(this, Hamburger);

    if (typeof mobile_menu != "undefined" && typeof hamburger_menu != "undefined") {
      this.mobile_menu = mobile_menu;
      this.hamburger_menu = hamburger_menu;
    } else {
      throw "You must provide an element";
    }

    if (typeof mobile_menu_open_class == "undefined") {
      this.mobile_menu_open_class = "open";
    } else {
      this.mobile_menu_open_class = mobile_menu_open_class;
    }

    this.event_listeners();
  }

  _createClass(Hamburger, [{
    key: "event_listeners",
    value: function event_listeners() {
      var _this = this;

      document.body.addEventListener("click", function (ev) {
   if (ev.path && !ev.path.includes(_this.mobile_menu) && !ev.path.includes(_this.hamburger_menu)) {
    _this.mobile_menu.classList.remove(_this.mobile_menu_open_class);
}
      });
    }
  }]);

  return Hamburger;
}();

module.exports = Hamburger;

},{}],6:[function(require,module,exports){
"use strict";

/*
* @param string Your query!
* @param Element Your element!
*/
function get(query, start) {
  var start_object = document;
  if (typeof start !== "undefined") start_object = start;
  var return_obj = {};
  var random_object = document.createElement("div");

  try {
    return_obj = start_object.querySelector(query);
  } catch (e) {
    return_obj = random_object;
  }

  if (!return_obj) return_obj = random_object;
  return return_obj;
}

function all_ev(query, ev, callback) {
  var items;

  if (typeof query === "string") {
    items = document.querySelectorAll(query);
  } else {
    items = query;
  }

  if (items) {
    items.forEach(function (item) {
      item.addEventListener(ev, function (event) {
        callback(item, event);
      });
    });
  }

  return false;
}
/*
    * @param NodeListOf<Element>
    * @param function
    */


function click(elements, callback) {
  elements.forEach(function (gallery_item) {
    gallery_item.addEventListener('click', function () {
      callback(gallery_item);
    });
  });
}

exports.get = get;
exports.all_ev = all_ev;
exports.click = click;

},{}],7:[function(require,module,exports){
"use strict";

var shuffle = require("./shuffle");

var randomize = require("./random_links");

var cart_runtime = require("./cart");

var faq_runtime = require("./faq");

var account_runtime = require("./account");

var product_runtime = require("./product");

var Hamburger = require("./hamburger");

var _require = require("./helpers"),
    get = _require.get,
    all_ev = _require.all_ev;

var Login = require('./login');

randomize();
var _current_variant = {};
var all_gallery_items = document.querySelectorAll('.gallery-item');
var background = document.querySelector('.mobile-header-inner-inner');
var cart_button = document.querySelector(".btn-add-to-cart");
var quantity_selector = document.querySelector("#quantity");

function wait_for_me(selector) {
  return new Promise(function (resolve) {
    var elapsed = 0;
    var check = setInterval(function () {
      var element = document.querySelector(selector);
      elapsed += 250;
      if (element || elapsed >= 20000) {
        clearInterval(check);
        resolve(element);
      }
    }, 250);
  });
}

document.addEventListener("DOMContentLoaded", function (ev) {
  var b_class = document.body.classList;
  var mobile_menu = document.querySelector(".mobile");
  var hamburger = document.querySelector(".hamburger");
  new Hamburger(mobile_menu, hamburger);

  if (b_class.contains("product")) {
    product_runtime(ev);
  } else if (b_class.contains("account")) {
    account_runtime(ev);
  } else if (b_class.contains("cart")) {
    cart_runtime(ev);
  } else if (b_class.contains("faq")) {
    faq_runtime(ev);
  } else if (b_class.contains("login")) {
    Login.init();
  }

  wait_for_me("#fsb_container").then(function (fsb) {
    if (fsb) document.body.classList.add("fsb");
  });
  var referrer = document.referrer;
  /*let emailpopup = document.querySelector('.email-capture');
  if (emailpopup && localStorage.getItem("popup") === null) {
      emailpopup.classList.remove('closed');
      localStorage.setItem("popup", true);
  }
   emailpopup.querySelector("form").addEventListener("submit", function (ev) {
      ev.preventDefault();
      let xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://glmail.prcr8.com/new_code');
       emailpopup.classList.add("active");
       xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xhr.onload = function (data) {
          // Request finished. Do processing here.
          setTimeout(() => {
              emailpopup.classList.add("closed");
          }, 2000);
      };
       let email = emailpopup.querySelector("input[type='email']").value;
        xhr.send("email="+email);
  });
    if (emailpopup) {
      emailpopup.querySelector('.close').addEventListener('click', function() {
          emailpopup.classList.add('closed');
      })
  }*/
});

function cart_update_animation(totalElement) {
  totalElement.classList.add('change');
  setTimeout(function () {
    totalElement.classList.remove('change');
  }, 400);
}

jQuery(function ($) {
  var cart_num = 0;

  if (document.body.classList.contains("product") || document.body.classList.contains("index")) {
    /* The goalposts moved! */
    var crt = function crt() {
      this.buttons = document.querySelectorAll(".btn-add-to-cart"); // this.classList = {};

      this.classList = this;

      this.remove = function (cls) {
        this.buttons.forEach(function (btn) {
          btn.classList.remove(cls);
        });
      };

      this.add = function (cls) {
        this.buttons.forEach(function (btn) {
          btn.classList.add(cls);
        });
      };
    };

    var toggle_added = function toggle_added() {
      add_to_cart_button.classList.remove("adding");
      add_to_cart_button.classList.add("added");

      if (quantity_selector) {
        quantity_selector.value = 1;
        add_to_cart_button.setAttribute("data-cart-quantity", "1");
      }

      cart_button = add_to_cart_button;
      get(".txt", cart_button).innerHTML = "";
      get(".price .inner", cart_button).style.opacity = "0";
      get(".price .inner", cart_button).style.display = "none";
      console.log(add_to_cart_button);
      var view_cart = add_to_cart_button.parentElement.querySelector('.btn.view-cart');
      if (view_cart) view_cart.classList.add('show');
    };

    var toggle_adding = function toggle_adding() {
      add_to_cart_button.classList.remove("added");
      add_to_cart_button.classList.remove("added-temp");
      add_to_cart_button.classList.add("adding");
      add_to_cart_button.parentElement.parentElement.parentElement.classList.add('active-still');
      cart_button = add_to_cart_button;
      og_text = cart_button.querySelector(".txt").innerText;
      get(".txt", cart_button).innerText = "";
      get(".price .inner", cart_button).style.opacity = "0";
      get(".sale-price", cart_button).style.display = "none";
    }; // let add_to_cart_button = new crt();


    var og_text = "";
    var loading_text = "Adding...";
    var add_to_cart_button = document.querySelector(".btn-add-to-cart");
    document.querySelectorAll(".btn-add-to-cart").forEach(function (btn) {
      btn.addEventListener("click", function (ev) {
        add_to_cart_button = btn;
      });
      btn.addEventListener("mouseenter", function (ev) {
        if (btn.classList.contains("added")) {
          btn.classList.remove("added");
          btn.classList.add("added-temp");
          var html = btn.getAttribute("data-original-html");

          if (html) {
            btn.setAttribute("data-swapped-html", btn.innerHTML);
            btn.innerHTML = html;
          }
        }
      });
      btn.addEventListener("mouseleave", function (ev) {
        if (btn.classList.contains("added-temp")) {
          btn.classList.remove("added-temp");
          btn.classList.add("added");
          var html = btn.getAttribute("data-swapped-html");

          if (html) {
            btn.setAttribute("data-original-html", btn.innerHTML);
            btn.innerHTML = html;
          }
        }
      });
    });
    $(document).on('cart.requestStarted', function (event, cart) {
      cart_num = cart.item_count;

      if (_current_variant.available || Object.entries(_current_variant).length === 0 && !document.querySelector(".product-header.out-of-stock") || document.body.classList.contains("index") // we want this behaviour by default on index...
      ) {
          var original_button_html = add_to_cart_button.innerHTML;
          add_to_cart_button.setAttribute("data-original-html", original_button_html);
          toggle_adding();
        }
    });
    var product_header = document.querySelector(".product-header");
    $(document).on('cart.requestComplete', function (event, cart) {
      if (cart_num == cart.item_count1 && typeof product_header !== "undefined" && !product_header.classList.contains("out-of-stock") && add_to_cart_button.getAttribute("data-cart-quantity") > 0) {
        alert("Your items were not added. It may be out of stock.");
      }

      if (_current_variant.available || Object.entries(_current_variant).length === 0 && !document.querySelector(".product-header.out-of-stock")) {
        setTimeout(function () {
          toggle_added();
        }, 1000);
      }
    });
  }

  $(document).on('cart.requestComplete', function (event, cart) {
    var cart_numbers = document.querySelectorAll("[data-cart-num]");
    cart_numbers.forEach(function (cart_number) {
      cart_number.innerText = cart.item_count; // update cart number

      cart_number.setAttribute("data-cart-num", cart.item_count);
    });

    if (document.body.classList.contains("cart")) {
      cart_runtime.update(cart);
      setTimeout(function () {
        cart_update_animation(cart_runtime.last_changed.closest(".cart-item").parentElement.querySelector(".total-price"));
      }, 200);
    }
  });
});
exports._current_variant = _current_variant;

},{"./account":1,"./cart":2,"./faq":3,"./hamburger":5,"./helpers":6,"./login":8,"./product":10,"./random_links":11,"./shuffle":12}],8:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Login =
/*#__PURE__*/
function () {
  function Login() {
    _classCallCheck(this, Login);
  }

  _createClass(Login, null, [{
    key: "init",
    value: function init() {
      Login.forgot_password_link = document.querySelector(".forgot-password");
      Login.forgot_password_form = document.querySelector('[action="/account/recover"]');
      Login.container = document.querySelector(".login-signup-container");
      Login.login_email = document.querySelector("[name='customer[email]']");
      Login.forgot_password_email = document.querySelector("[name='email']");
      Login.forgot_password();
    }
  }, {
    key: "type_email",
    value: function type_email() {
      Login.login_email.addEventListener("input", function (ev) {
        Login.forgot_password_email.value = ev.target.value;
      });
    }
  }, {
    key: "forgot_password",
    value: function forgot_password() {
      Login.forgot_password_link.addEventListener("click", function (ev) {
        Login.click_forgot_password(ev);
      });
    }
  }, {
    key: "click_forgot_password",
    value: function click_forgot_password(ev) {
      if (Login.container.classList.contains("forgot")) {
        Login.container.classList.remove("forgot");
      } else {
        Login.container.classList.add("forgot");
      }
    }
  }]);

  return Login;
}();

module.exports = Login;

},{}],9:[function(require,module,exports){
"use strict";

function Message(message, type, message_element) {
  if (typeof type === "undefined") type = "success";
  if (typeof message === "undefined") throw "Must provide a message";
  if (typeof message_element === "undefined") message_element = document.querySelector(".message");
  this.message = message, this.type = type, this.message_element = message_element;
  message_element.classList.add("show");
  message_element.classList.remove("empty");
  message_element.classList.add(type);
  message_element.querySelector(".message-inner").innerText = message;
  return this;
}

module.exports = Message;

},{}],10:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _readOnlyError(name) { throw new Error("\"" + name + "\" is read-only"); }

var wait_for_me = require("./wait_for_me");

var _require = require("./helpers"),
    get = _require.get,
    all_ev = _require.all_ev,
    click = _require.click;

var _require2 = require("./index");

function product_runtime(ev) {
  var _current_variant = _require2._current_variant;
  var all_gallery_items = document.querySelectorAll('.gallery-item');
  var background = document.querySelector('.mobile-header-inner-inner');
  var cart_button = document.querySelector(".btn-add-to-cart");
  var quantity_selector = document.querySelector("#quantity");

  function q_selectors() {
    var quantity_selector = document.getElementById("quantity-selector");
    var quantity = quantity_selector.querySelector("[type='number']");

    function sync_quantity() {
      var value = Math.floor(Number(quantity.value));
      if (!Number.isFinite(value) || value < 1) value = 1;
      quantity.value = value;
      cart_button.setAttribute("data-cart-quantity", value);
      return value;
    }

    function spin(value) {
      quantity.value = Math.max(1, sync_quantity() + value);
      sync_quantity();
    }

    quantity.addEventListener("input", function () {
      if (quantity.value !== "") sync_quantity();
    });
    quantity.addEventListener("change", sync_quantity);
    quantity.addEventListener("blur", sync_quantity);
    cart_button.addEventListener("click", sync_quantity);
    var spinners = quantity_selector.querySelectorAll(".spinner").forEach(function (spinner) {
      spinner.addEventListener("click", function (ev) {
        if (spinner.classList.contains("increment")) {
          spin(1);
        } else {
          spin(-1);
        }
      });
    });
  }

  q_selectors();

  /* On click, transition */

  click(all_gallery_items, function (gallery_item) {
    transition_to(gallery_item.getAttribute('data-background-image'));
  });
  /*
  * @param string
  */

  function transition_to(url) {
    var new_background = background.cloneNode(true); // never let it stack up too much; lags firefox otherwise.
    console.log("url" , new_background)
    if (background.parentElement.childElementCount > 1) {
      background.nextSibling.remove();
    }

    background.parentElement.appendChild(new_background);
    new_background.style.backgroundImage = "url(".concat(url, ")");
  }
  /* Lazy load all gallery images */


  lazy_load(all_gallery_items, function (ev) {});
  /*
  * @param Element[]
  * @param function
  * */

  function lazy_load(all, callback) {
    var promises = [];
    all.forEach(function (image) {
      promises.push(new Promise(function (resolve, reject) {
        var new_image = new Image();
        new_image.src = image.getAttribute("data-background-image");
        new_image.addEventListener("load", function () {
          resolve(new_image.src);
        });
      }));
    });
    Promise.all(promises).then(function (values) {
      callback(values);
    })["catch"](function (err) {
      return console.alert(err);
    });
  }

  var selectors = document.querySelectorAll('.glacio-selector');

  function selected_variant() {
    var values = Array.from(selectors).filter(function (selector) {
      return selector.getAttribute('data-selected') === 'true';
    }).map(function (selector) {
      return selector.getAttribute('value');
    });
    return variant_details.variants.find(function (variant) {
      return values.every(function (value) {
        return variant.options.indexOf(value) !== -1;
      });
    });
  }

  function show_variant(variant) {
    Object.keys(_current_variant).forEach(function (key) { delete _current_variant[key]; });
    Object.assign(_current_variant, variant || { available: false });
    var available = Boolean(variant && variant.available);
    document.querySelector('.product-header').classList.toggle('out-of-stock', !available);
    cart_button.classList.remove('added', 'added-temp', 'adding');
    cart_button.removeAttribute('data-original-html');
    cart_button.removeAttribute('data-swapped-html');
    cart_button.setAttribute('aria-disabled', String(!available));
    if (available) {
      cart_button.setAttribute('data-cart-add', variant.id);
    } else {
      cart_button.removeAttribute('data-cart-add');
    }
    cart_button.querySelector('.txt').textContent = variant ? (available ? 'Add to Cart' : 'Out of Stock') : 'Unavailable';
    var price = cart_button.querySelector('.price .inner');
    price.style.opacity = '1';
    price.style.display = '';
    price.textContent = variant ? '$' + (variant.price / 100).toFixed(2) : '';
    var sale = cart_button.querySelector('.sale-price');
    sale.style.display = '';
    sale.textContent = variant && variant.compare_at_price > variant.price ? '$' + (variant.compare_at_price / 100).toFixed(2) : '';
    var select = document.querySelector('#productSelect');
    if (select) select.value = variant ? String(variant.id) : '';
    var color = document.querySelector('.color-single[data-selected="true"]');
    var label = document.querySelector('span.color');
    if (color && label) label.textContent = color.getAttribute('value');
    if (variant && variant.featured_image && variant.featured_image.src) {
      transition_to(variant.featured_image.src);
    }
  }

  selectors.forEach(function (selector) {
    selector.addEventListener('click', function () {
      var type = selector.getAttribute('data-type');
      selectors.forEach(function (other) {
        if (other.getAttribute('data-type') === type) {
          other.setAttribute('data-selected', String(other === selector));
        }
      });
      show_variant(selected_variant());
    });
  });

  var requested_id = new URLSearchParams(window.location.search).get('variant');
  var initial_variant = variant_details.variants.find(function (variant) {
    return String(variant.id) === requested_id;
  }) || variant_details.variants.find(function (variant) {
    return variant.available;
  }) || variant_details.variants[0];
  selectors.forEach(function (selector) {
    selector.setAttribute('data-selected', String(Boolean(initial_variant && initial_variant.options.indexOf(selector.getAttribute('value')) !== -1)));
  });
  show_variant(initial_variant);
  cart_button.addEventListener('click', function (event) {
    if (cart_button.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  });
  /*
  * @param Element
  * @param Element
  * @param string
  * @param function
  */

  function CoolSelect(true_select, fake_select, fake_select_selector) {
    this.true_select = true_select;
    this.fake_select = fake_select;
    /* Get all fake select elements */

    try {
      this.fake_select_options = this.fake_select.querySelectorAll(fake_select_selector);
    } catch (e) {
      return false;
    }

    return this;
  }

  CoolSelect.prototype = {
    /*
    * @param function | optional
    */
    select: function select(callback) {
      var _this2 = this;

      this.fake_select_options.forEach(function (fake_option) {
        fake_option.addEventListener("click", function (ev) {
          var selected_value = fake_option.getAttribute('value');

          _this2.true_select.querySelectorAll("option").forEach(function (option) {
            return option.removeAttribute("selected");
          });

          var true_option = _this2.true_select.querySelector("option[value='".concat(selected_value, "']"));

          true_option.setAttribute("selected", "");
          if (typeof callback !== "undefined") callback(selected_value);
        });
      });
    }
  };
  var quantities = [];
  var colors = [];

  if (document.querySelector('.color-selector')) {
    /*let color_selector = new CoolSelect(
        document.querySelector("#productSelect"),
        document.querySelector('.color-selector'),
        ".color-single"
    );
     color_selector.select(color_select);
     function color_select(variant_id) {
        let color = document.querySelector(`.color-single[value='${variant_id}']`).getAttribute("data-color");
        cart_button.setAttribute("data-cart-add", variant_id);
        document.querySelector(".color-selector .color").innerText = color;
         variant_details.variants.forEach(v => {
            if (v.id == variant_id) {
                 get(".price").innerText = "$ " + (v.price / 100).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,');
                get(".product-header h2").innerText = v.name;
                return false;
            }
        });
         filter_images(color);
    }*/
    var filter_images = function filter_images(color) {
      all_gallery_items.forEach(function (image) {
        var title = image.getAttribute("title").toLowerCase();

        if (title == color.toLowerCase() || title == variant_details.title.toLowerCase()) {
          image.style.display = "block";
        } else {
          image.style.display = "none";
        }
      });
    };
  }



  window.addEventListener("load", function (ev) {});
}

module.exports = product_runtime;

},{"./helpers":6,"./index":7,"./wait_for_me":13}],11:[function(require,module,exports){
"use strict";

var shuffle = require("./shuffle");
/*
* Random extra links
* */


var randomize = function randomize() {
  if (typeof randomized_links !== "undefined") {
    var block = document.querySelector(".extra-links .block");
    randomized_links = shuffle(randomized_links);
 console.log("shuffle" , shuffle)
    for (var i = 0; i < 3; i++) {
      if (typeof randomized_links[i] !== "undefined") {
        var pieces = randomized_links[i].split(":");
        // console.log("pieces" , pieces)
        var block_clone = block.cloneNode(true);
        block_clone.querySelector(".img").style.backgroundImage = "url(" + pieces[1] + ")";
        block_clone.querySelector(".btn-alt").href = pieces[0];
        block_clone.querySelector(".text h2").innerText = pieces[2];
        block_clone.querySelector(".text a").innerText = pieces[3];
        document.querySelector(".extra-links .inner").appendChild(block_clone);
      }
    }

    var side = Math.round(Math.random()) ? "left" : "right";
    console.log("side" , side)
    document.querySelector(".extra-links .block").remove();
    document.querySelector(".extra-links").classList.add(side);
  }
};

module.exports = randomize;

},{"./shuffle":12}],12:[function(require,module,exports){
"use strict";

// Put your application javascript here
var shuffle = function shuffle(array) {
  var currentIndex = array.length;
  var temporaryValue, randomIndex; // While there remain elements to shuffle...

  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1; // And swap it with the current element.

    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
console.log(array , "test")
  return array;
  
};

module.exports = shuffle;

},{}],13:[function(require,module,exports){
"use strict";

function wait_for_me(selector) {
  return new Promise(function (resolve) {
    var elapsed = 0;
    var check = setInterval(function () {
      var element = document.querySelector(selector);
      elapsed += 250;
      if (element || elapsed >= 20000) {
        clearInterval(check);
        resolve(element);
      }
    }, 250);
  });
}

module.exports = wait_for_me;

},{}]},{},[7])
